import React from 'react';
import '../styles/main.css'

const ToolTip = (props) =>
  <div className="ToolTip">
    Tooltip
  </div>


export default ToolTip
